<mat-card>
	<mat-card-header>
		<mat-card-title>
			<b i18n>MEDICINA BIORREGULADORA</b>
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<div class="share-buttons">
			<button mat-icon-button [matMenuTriggerFor]="shareMenu" i18n-aria-label="@@medicina-biorreguladora-share-aria-label|Accessible label of the share icon button" aria-label="Compartir" matTooltip="Compartir" i18n-matTooltip="@@medicina-biorreguladora-share-tooltip|Tooltip for the share icon button" (menuOpened)="loadShareWidgets()">
				<mat-icon>share</mat-icon>
			</button>
			<mat-menu #shareMenu="matMenu">
				<button mat-menu-item>
					<div class="fb-share-button" [attr.data-href]="shareUrl" [attr.data-layout]="'button_count'" [attr.data-size]="'large'">
						<a target="_blank" rel="noopener" [href]="shareFacebookUrl" class="fb-xfbml-parse-ignore" i18n="@@medicina-biorreguladora-facebook-share|Facebook share link inside the share menu">Compartir</a>
					</div>
				</button>
				<button mat-menu-item>
					<a [href]="shareXUrl" target="_blank" rel="noopener" class="twitter-share-button" [attr.data-size]="'large'" [attr.data-url]="shareUrl">Tweet</a>
				</button>
			</mat-menu>
		</div>
		<div class="content-container">
			<div class="content-container-row">
				<div class="content-item">
					<div class="content-item-img-container">
						<img class="content-item-img" ngSrc="images/foliculo.png" i18n-alt alt="lyo medical" fill>
					</div>
					<h4 i18n><b>DERMO REGULADOR:</b> Ayuda al proceso de inflamación y cicatrización</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/articulacion.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>OSTEOMUSCULAR:</b> Ideal para procesos inflamatorios osteoarticulares</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/corazon.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>VITAL:</b> Diseñado para regular síntomas como fatiga por estilos de vida inadecuados</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/pulmones.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>INMUNOLÓGICO:</b> Estimula el sistema inmune y mejora la respuesta frente a cualquier infección</h4>
				</div>
			</div>
			<div class="content-container-row">
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/higado.webp" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>DETOX:</b> Elimina cargas tóxicas del organismo estimulando la detoxificación fisiológica</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/estomago.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>GASTRO REGULADOR:</b> Biorregulación de la mucosa ayudando a síntomas de intestino irritable, dispepsia</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/intestinos.webp" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>METABOLIC REGULADOR:</b> Bioregulador y estimulante profundo ayudando a controlar obesidad, dislipidemia</h4>
				</div>
				<div class="content-item">
					<img class="content-item-img" ngSrc="images/rinones.png" i18n-alt alt="lyo medical" [width]="250" [height]="250">
					<h4 i18n><b>HORMO REGULADOR:</b> Apoya el adecuado funcionamiento del eje hormonal</h4>
				</div>
			</div>
		</div>
	</mat-card-content>
</mat-card>
